import React from "react";
import Tooltip from "./Tooltip";


function SearchInput({ customInput }) {
  const { label, name, value, action, tooltipBool, tooltipText, disabled, placeholder } = customInput;

  return (
    <div className="filter-title form-field">
      <label htmlFor={name}>
        {label}
        {tooltipBool === true && <Tooltip text={tooltipText} />}
      </label>
      <input
        type="text"
        name={name}
        id={name}
        value={value}
        onChange={action}
        disabled={disabled}
        placeholder={placeholder || "Search..."}
        className="search-input"
      />
    </div>
  );
}

export default SearchInput;
